const baseApiUrl = process.env.VUE_APP_MAIN_DOMAIN_URL;

// A failed write is never retried automatically: it may already have reached the server.
export async function requestJson(path, { method = "GET", body, timeoutMs = 20000, headers = {} } = {}) {
  const controller = new AbortController();
  let timer;
  const timeout = new Promise((resolve, reject) => {
    timer = setTimeout(() => {
      controller.abort();
      const error = new Error("Request timed out");
      error.uncertain = true;
      reject(error);
    }, timeoutMs);
  });
  try {
    return await Promise.race([
      (async () => {
        const response = await fetch(`${baseApiUrl}${path}`, {
          method, body, signal: controller.signal,
          headers: { "Content-Type": "application/json", Accept: "application/json", "Cache-Control": "no-cache", ...headers },
        });
        const result = await response.json();
        if (!response.ok) {
          const error = new Error(`Request failed: ${response.status}`);
          error.status = response.status;
          error.details = result;
          throw error;
        }
        return result;
      })(),
      timeout,
    ]);
  } finally {
    clearTimeout(timer);
  }
}

async function cartRequest(path, method = "GET", body, headers = {}) {
  const result = await requestJson(path, { method, body, headers });
  const items = result.data?.items;
  if (!items || typeof items !== "object") throw new Error("Invalid cart response");
  result.data.items = Object.values(items);
  return result;
}

export const GET_MAIN_CATEGORIES = () => requestJson("shop/home-categories/get");
export const GET_MAIN_BUNNER = () => requestJson("shop/banners/get");
export const GET_CATEGORIES = () => requestJson("shop/categories");
export const GET_CATEGORY = id => requestJson(`shop/categories/${id}`);
export const GET_ALL_PRODUCTS = () => requestJson("shop/products");
export const GET_ONE_PRODUCT = id => requestJson(`shop/products/${id}`);
export const GET_SHOP_PRODUCTS_SEARCH = ({ q = "", category_ids = null, price_from, price_to, sort = "", page = 1 } = {}) =>
  requestJson(`shop/products/search?page=${page}`, { method: "POST", body: JSON.stringify({ search: q, category_ids, price_from, price_to, sort }) });
const favoriteHeaders = () => ({ "X-Telegram-Init-Data": window.Telegram?.WebApp?.initData || "" });
export const GET_FAVORITES = () => requestJson("shop/favorites", { headers: favoriteHeaders() });
export const SET_FAVORITE = (id, saved) => requestJson(`shop/favorites/${encodeURIComponent(id)}`, { method: saved ? "PUT" : "DELETE", headers: favoriteHeaders() });
export const GET_SHOP_ORDER_NUMBER = id => requestJson(`shop/order/get?customer_id=${encodeURIComponent(id)}`);
export const GET_CITYS = ({ order_id, q }) => requestJson(`shop/order/city?${new URLSearchParams({ order_id, q })}`);
export const GET_ORDER_BRANCH = ({ order_id, uuid_city }) => requestJson(`shop/order/branch?${new URLSearchParams({ order_id, uuid_city })}`);
export const SET_ORDER_BRANCH_SAVE = body => requestJson("shop/order/branch-save", { method: "POST", body });
export const GET_COME_TO_PAY = id => requestJson(`shop/order/to-pay?order_id=${encodeURIComponent(id)}`);
export const GET_ORDER_CART = id => cartRequest(`shop/cart/get?order_id=${id}`);
export const GET_ORDERS = () => requestJson('shop/order/orders', { headers: favoriteHeaders() });
export const GET_ORDER_DETAILS = id => requestJson(`shop/order/details/${encodeURIComponent(id)}`, { headers: favoriteHeaders() });
export const REPEAT_ORDER = (id, requestKey) => cartRequest(`shop/order/repeat/${encodeURIComponent(id)}`, 'POST', JSON.stringify({ request_key: requestKey }), favoriteHeaders());
export const GET_ADD_TO_CART = body => cartRequest("shop/cart/add", "POST", body);
export const GET_ADD_COUNTER_CART = body => cartRequest("shop/cart/plus", "POST", body);
export const GET_MINUS_COUNTER_CART = body => cartRequest("shop/cart/minus", "POST", body);
export const GET_DELETE_CART = body => cartRequest("shop/cart/delete", "DELETE", body);
export const GET_CHANGE_PRODUCT_QUANTITY = body => cartRequest("shop/cart/quantity", "POST", body);
